import React from 'react';
import { GiftCardContract } from '../../../types/GiftCard';
import { CartPaymentProfileContract } from '../../../types/PaymentProfile';
import PaymentSummary from '../../summary/PaymentSummary';
import { SectionSummaryGroupPosition } from '../../summary/SectionSummary';

export type AuthenticatedPaymentSectionProps = {
  paymentProfile: CartPaymentProfileContract | null;
  groupPosition?: SectionSummaryGroupPosition;
  onPaymentEdit: () => void;
  appliedGiftCards: GiftCardContract[];
};

const AuthenticatedPaymentSection: React.FC<
  AuthenticatedPaymentSectionProps
> = ({
  appliedGiftCards,
  paymentProfile,
  groupPosition,
  onPaymentEdit,
}: AuthenticatedPaymentSectionProps) => {
  return (
    <PaymentSummary
      onPaymentEdit={onPaymentEdit}
      paymentProfile={paymentProfile}
      groupPosition={groupPosition}
      appliedGiftCards={appliedGiftCards}
    />
  );
};

export default AuthenticatedPaymentSection;
